(() => {
  function initialize(root = document) {
    root.querySelectorAll('[data-av-comparison]').forEach((section) => {
      if (section.dataset.initialized) return;
      const select = section.querySelector('[data-av-filter]');
      const rows = [...section.querySelectorAll('[data-av-model]')];
      if (!select || !rows.length) return;
      section.dataset.initialized = 'true';
      section.querySelector('.av-filter').hidden = false;
      select.addEventListener('change', () => {
        rows.forEach((row) => {
          const matches = select.value === 'all' ||
            (select.value === 'portable' && row.dataset.liftType.includes('portable')) ||
            (select.value === 'capacity' && Number(row.dataset.capacity) >= 7000);
          row.hidden = !matches;
        });
        section.querySelector('[data-av-result]').textContent = select.selectedOptions[0].textContent;
      });
    });
  }
  initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
